import CbayelOpinionForm from './opinion-form';
export default CbayelOpinionForm;
